import OnBoarding from "@/components/dialog/OnBoarding";
import Sidebar from "@/components/Sidebar";
import { Button } from "@/components/ui/button";
import { authClient } from "@/lib/better-auth/client";
import MainLayout from "@/lib/layout/MainLayout";
import { useQueryClient } from "@tanstack/react-query";
import {
  createFileRoute,
  Link,
  Outlet,
  useLocation,
} from "@tanstack/react-router";
import { Menu } from "lucide-react";
import { useEffect, useRef, useState } from "react";

export const Route = createFileRoute("/_dashboard")({
  component: RouteComponent,
  // async loader({ context }) {
  //   if (!context.userSession?.user) {
  //     return 0;
  //   }
  //   return await getNotificationCount();
  // },
});

function RouteComponent() {
  // const pathname = useLocation({
  //   select: (location) => location.pathname,
  // });
  // const notificationCountFromLoader = useLoaderData({ from: '/_dashboard' });
  // const queryClient = useQueryClient();
  const [isMobile, setIsMobile] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { data: userSession } = authClient.useSession();

  // const [notificationCount, setNotificationCount] = useState(0);

  // const wsRef = useRef<WebSocket | null>(null);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  // useEffect(() => {
  //   if (!userSession?.session.token) {
  //     // no token, close websocket
  //     if (wsRef.current) {
  //       wsRef.current.close();
  //       wsRef.current = null;
  //     }
  //     return;
  //   }

  //   // open websocket
  //   const ws = new WebSocket(
  //     `ws://localhost:8080/ws?session_token=${userSession.session.token}`,
  //   );

  //   wsRef.current = ws;

  //   ws.onmessage = (event) => {
  //     try {
  //       const data = JSON.parse(event.data);
  //       if (data.type === 'notification') {
  //         queryClient.invalidateQueries({
  //           queryKey: [QUERY_KEYS.NOTIFICATIONS],
  //         });
  //         setNotificationCount((prevCount) => prevCount + 1);
  //       }
  //       console.log('Received message:', data);
  //     } catch (e) {
  //       console.error('Invalid message', e);
  //     }
  //   };

  //   // cleanup
  //   return () => {
  //     ws.close();
  //     wsRef.current = null;
  //   };
  // }, [userSession?.session.token]);

  // useEffect(() => {
  //   if (pathname === '/notifications') {
  //     setNotificationCount(0);
  //   }
  // }, [pathname]);

  const handleCloseSidebar = () => {
    setSidebarOpen(false);
  };

  return (
    <>
      {userSession?.user && (
        <OnBoarding
          open={
            !userSession.user.countryCode || !userSession.user.gender
              ? true
              : false
          }
        />
      )}
      <div className="bg-background h-screen transition-colors duration-300">
        <div className="flex">
          {/* Sidebar */}
          <Sidebar
            currentUser={userSession?.user}
            isMobile={isMobile}
            isOpen={sidebarOpen}
            onClose={handleCloseSidebar}
            // notificationCount={notificationCount}
          />

          {/* Main Content */}
          <div className="flex flex-1 flex-col">
            {/* Mobile Header */}
            {isMobile && (
              <header className="border-border-wu bg-background sticky top-0 z-30 flex items-center justify-between border-b p-4">
                <Button
                  aria-label="Open sidebar"
                  onClick={() => setSidebarOpen(true)}
                  variant={"ghost"}
                  size={"custom"}
                  className="hover:bg-button-hover-background-wu dark:hover:bg-button-hover-background-wu p-2 text-black transition-colors dark:text-white"
                >
                  <Menu className="size-6" />
                </Button>
                <h1 className="text-xl font-bold text-gray-900 dark:text-white">
                  Would<span className="text-primary-wu"> U</span>
                </h1>

                {!userSession?.user ? (
                  <Link
                    to="/sign-up"
                    className="bg-primary-wu fixed bottom-4 right-4 font-semibold flex justify-center gap-2 rounded-full px-4 py-2 text-white transition-colors hover:brightness-90"
                  >
                    Sign Up
                  </Link>
                ) : null}
              </header>
            )}

            <MainLayout>
              <Outlet />
            </MainLayout>
          </div>
        </div>
      </div>
    </>
  );
}
